import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreditoRoutingModule } from './credito-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CreditoRoutingModule,
  ]
})
export class CreditoModule { }
